export default {"src":"/_next/static/media/integration-app.7a8bf23a.svg","height":20,"width":33,"blurWidth":0,"blurHeight":0};